export const getProductionData = ({ state }) => state.production.unassignedList;
